<head>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.5.0/Chart.bundle.min.js"></script>
  </head>
  <div class="main-tab-title-box">
    <mat-card-title class="main-title">Lexis: English Vocabulary Profile <br>({{currentEnglishType2}})</mat-card-title>
    <div>
      <analysis-options></analysis-options>
    </div>
  </div>
  <mat-card-content>
    <div class="box-login">
        <span class="main-box-title-14">As this is a subscriber’s feature, you are seeing sample results. In order to  <br>see the real results of your text, <u class="main-box-value-14-bold"><a href="https://textinspector.com/subscription-details/" style="color: #2A3654;" target="_blank" rel="noopener noreferrer">SUBSCRIBE NOW.</a></u></span>
    </div>

    
<span class="main-box-title-14">This tool assigns each word a CEFR level, according to the English Vocabulary Profile from Cambridge University Press. You can change the English type in the Analysis Options above. <br><br>
    If you want to correct the analysis, click on the "<img src="./assets/images/project-icon.svg" class="icon-project" style="cursor: inherit;">" icon next to a word below, change the tag, then click Update.</span>
  
    <div id="button-switch-box">
      <div class="button-container left" [ngClass]="{'selected': isSelected('wl')}" (click)="selectMenuItem('wl')">
        <div style="margin-top: 8px;">
          <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;" src="./assets/images/extra_tab_icons/word-list-icon.svg">
          <span class="main-box-title-14" style="padding-top: 2px;">Word List</span>
        </div>
      </div>
      <div class="separator"></div>
      <div class="button-container right" [ngClass]="{'selected': isSelected('wc')}" (click)="selectMenuItem('wc')">
        <div style="margin-top: 8px;">
          <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;" src="./assets/images/extra_tab_icons/charts-icon.svg">
          <span class="main-box-title-14" style="padding-top: 2px;">Word Charts</span>
        </div>
      </div>
    </div>
    <!--------------------------------------------->
    <!--------------------------------------------->
    <!-----------------WORD LIST------------------->
    <!--------------------------------------------->
    <!--------------------------------------------->
  
    <ng-container *ngIf="selectedMenuItem === 'wl'">
      <div id="buttons-box">
        <div style="width: 70px;">
  
        </div>
        <span style="padding-left: 15px;">
          <button class="icon-button">
            <span class="button-block"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" class="export-con"></div><span>Lexis: EVP
              Export</span></span>
          </button>
        </span>
  
      </div>
  
      <!--------------------------->
      <!--------------------------->
      <!------Advanced Mode-------->
      <!--------------------------->
      <!--------------------------->
      <ng-container *ngIf="checked">
        <div class="div_scroll_box">
        <div id="evp-box" style="text-align: left;">
          <div style="width: 80px;">
            <button class="button-seeAll" type="button">
              <img class="eye-icon" style="padding-left: 10px;" src="./assets/images/eye-icon.svg">
              <span class="main-box-title-12">See All</span>
            </button>
          </div>
          <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px; width: 60px;">CEFR</div>
          <div style=" text-align: left; width: 100px;">
            <div class="main-box-title-12">Types (Unique tokens)</div>
          </div>
          <div class="main-box-title-12" style="align-items: flex-end; display: flex; height: 30px;  width: 95px;">Tokens
            <div class="tooltip-container">
              <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
              <span class="tooltip-text">Tokens are similar to words, but include punctuation and other elements.</span>
            </div>
          </div>
          <div style=" text-align: left; width: 83px;">
            <div class="main-box-title-12">Cumul %</div>
            <div class="main-box-title-12">Types
              <div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">This shows the cumulative percentage of types (unique tokens) in each category, which is a running total of percentages, as you descend down the table. </span>
              </div>
            </div>
          </div>
          <div style=" text-align: left; width: 55px;"> 
            <div class="main-box-title-12">Cumul %</div>
            <div class="main-box-title-12">Tokens
              <div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">This shows the cumulative percentage of tokens in each category, which is a running total of percentages, as you descend down the table.</span>
              </div>
            </div>
          </div>
          <div style="width: 30px; height: 20px;"></div>
        </div>
  
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['A1']}" (click)="toggleExpand('A1')">
            <div id="div_eye_icon">
            <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="div_box_score">
              <div id="box-score" style="background-color: #F66B2D;">
                <div style="text-align: center; align-items: center; width: 30px;">A1</div>
              </div>
            </div>
            <div class="main-box-title-14" id="div_u_words">{{unique_words_A1 ? unique_words_A1 : "--"}} ({{cumul_unique_A1 ? cumul_unique_A1 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_words">{{words_A1 ? words_A1 : "--"}} ({{cumul_words_A1 ? cumul_words_A1 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_c_u_words">{{datos_pagina_A1.suma_unique_words ? datos_pagina_A1.suma_unique_words : "--"}}%</div>
            <div class="main-box-title-14" id="div_c_words">{{datos_pagina_A1.suma_cumul_words ? datos_pagina_A1.suma_cumul_words : "--"}}%</div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
  
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['A1']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['A1']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk"  >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
              </div>
            </div>
          </div>
        </div>
  
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['A2']}" (click)="toggleExpand('A2')">
            <div id="div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="div_box_score">
              <div id="box-score" style="background-color: #24908E;">
                <div style="text-align: center; align-items: center; width: 30px;">A2</div>
              </div>
            </div>
            <div class="main-box-title-14" id="div_u_words">{{unique_words_A2 ? unique_words_A2 : "--"}} ({{cumul_unique_A2 ? cumul_unique_A2 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_words">{{words_A2 ? words_A2 : "--"}} ({{cumul_words_A2 ? cumul_words_A2 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_c_u_words">{{datos_pagina_A2.suma_unique_words ? datos_pagina_A2.suma_unique_words : "--"}}%</div>
            <div class="main-box-title-14" id="div_c_words">{{datos_pagina_A2.suma_cumul_words ? datos_pagina_A2.suma_cumul_words : "--"}}%</div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['A2']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['A2']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
  
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['B1']}" (click)="toggleExpand('B1')">
            <div id="div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="div_box_score">
              <div id="box-score" style="background-color: #F41425;">
                <div style="text-align: center; align-items: center; width: 30px;">B1</div>
              </div>
            </div>
            <div class="main-box-title-14" id="div_u_words">{{unique_words_B1 ? unique_words_B1 : "--"}} ({{cumul_unique_B1 ? cumul_unique_B1 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_words">{{words_B1 ? words_B1 : "--"}} ({{cumul_words_B1 ? cumul_words_B1 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_c_u_words">{{datos_pagina_B1.suma_unique_words ? datos_pagina_B1.suma_unique_words : "--"}}%</div>
            <div class="main-box-title-14" id="div_c_words">{{datos_pagina_B1.suma_cumul_words ? datos_pagina_B1.suma_cumul_words : "--"}}%</div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['B1']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['B1']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['B2']}" (click)="toggleExpand('B2')">
            <div id="div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="div_box_score">
              <div id="box-score" style="background-color: #1C6C34;">
                <div style="text-align: center; align-items: center; width: 30px;">B2</div>
              </div>
            </div>
            <div class="main-box-title-14" id="div_u_words">{{unique_words_B2 ? unique_words_B2 : "--"}} ({{cumul_unique_B2 ? cumul_unique_B2 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_words">{{words_B2 ? words_B2 : "--"}} ({{cumul_words_B2 ? cumul_words_B2 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_c_u_words">{{datos_pagina_B2.suma_unique_words ? datos_pagina_B2.suma_unique_words : "--"}}%</div>
            <div class="main-box-title-14" id="div_c_words">{{datos_pagina_B2.suma_cumul_words ? datos_pagina_B2.suma_cumul_words : "--"}}%</div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['B2']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['B2']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['C1']}" (click)="toggleExpand('C1')">
            <div id="div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="div_box_score">
              <div id="box-score" style="background-color: #2C51F5;">
                <div style="text-align: center; align-items: center; width: 30px;">C1</div>
              </div>
            </div>
            <div class="main-box-title-14" id="div_u_words">{{unique_words_C1 ? unique_words_C1 : "--"}} ({{cumul_unique_C1 ? cumul_unique_C1 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_words">{{words_C1 ? words_C1 : "--"}} ({{cumul_words_C1 ? cumul_words_C1 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_c_u_words">{{datos_pagina_C1.suma_unique_words ? datos_pagina_C1.suma_unique_words : "--"}}%</div>
            <div class="main-box-title-14" id="div_c_words">{{datos_pagina_C1.suma_cumul_words ? datos_pagina_C1.suma_cumul_words : "--"}}%</div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['C1']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['C1']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['C2']}" (click)="toggleExpand('C2')">
            <div id="div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="div_box_score">
              <div id="box-score" style="background-color: #8A268C;">
                <div style="text-align: center; align-items: center; width: 30px;">C2</div>
              </div>
            </div>
            <div class="main-box-title-14" id="div_u_words">{{unique_words_C2 ? unique_words_C2 : "--"}} ({{cumul_unique_C2 ? cumul_unique_C2 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_words">{{words_C2 ? words_C2 : "--"}} ({{cumul_words_C2 ? cumul_words_C2 : "--"}}%)</div>
            <div class="main-box-title-14" id="div_c_u_words">{{datos_pagina_C2.suma_unique_words ? datos_pagina_C2.suma_unique_words : "--"}}%</div>
            <div class="main-box-title-14" id="div_c_words">{{datos_pagina_C2.suma_cumul_words ? datos_pagina_C2.suma_cumul_words : "--"}}%</div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['C2']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['C2']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['UNLISTED']}" (click)="toggleExpand('UNLISTED')">
            <div id="div_eye_icon_u">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="div_box_score_u">
              <div id="box-score_u" style="background-color: #F3F3F5; color: #2A3654;">
                <div style="text-align: center; align-items: center;">Unlisted</div>
              </div>
              <div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">Words in your text that are not found in the EVP word list.</span>
              </div>
            </div>
            <div class="main-box-title-14" id="div_u_words">{{unique_words_unlisted ? unique_words_unlisted : "--"}} ({{cumul_unique_unlisted ? cumul_unique_unlisted : "--"}}%)</div>
            <div class="main-box-title-14" id="div_words">{{words_unlisted ? words_unlisted : "--"}} ({{cumul_words_unlisted ? cumul_words_unlisted : "--"}}%)</div>
            <div class="main-box-title-14" id="div_c_u_words">{{datos_pagina_unlisted.suma_unique_words ? datos_pagina_unlisted.suma_unique_words : "--"}}%</div>
            <div class="main-box-title-14" id="div_c_words">{{datos_pagina_unlisted.suma_cumul_words ? datos_pagina_unlisted.suma_cumul_words : "--"}}%</div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['UNLISTED']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['UNLISTED']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk"  >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
        
        
      </ng-container>
  
      <!--------------------------->
      <!--------------------------->
      <!--------Simple Mode-------->
      <!--------------------------->
      <!--------------------------->
      <ng-container *ngIf="!checked">
        <div class="div_scroll_box">
        <div id="evp-box" style="text-align: left; justify-content: none; margin-bottom: 0px;">
          <div style="width: 100px;">
            <button class="button-seeAll-Simple" type="button">
              <img class="eye-icon" style="padding-left: 8px; margin-right: 4px;" src="./assets/images/eye-icon.svg">
              <span class="main-box-title-12">See All</span>
            </button>
          </div>
          <div class="main-box-title-12">CEFR</div>
          <div style="width: 25px; height: 20px; "></div>
          <div class="main-box-title-12" style="width: 100px; height: 20px; ">Types (Unique tokens)</div>
          <div class="main-box-title-12" style="width: 40px; height: 20px; ">Tokens
            <div class="tooltip-container">
              <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
              <span class="tooltip-text">Tokens are similar to words, but include punctuation and other elements.</span>
            </div>
          </div>
          <div style="width: 86px; height: 20px; "></div>
          <div style="width: 90px; height: 20px; "></div>
        </div>
  
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['A1']}" (click)="toggleExpand('A1')">
            <div id="i_div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="i_div_box_score">
              <div id="i_box-score" style="background-color: #F66B2D;">
                <div style="text-align: center; align-items: center; width: 30px;">A1</div>
              </div>
            </div>
            <div style="width: 30px; height: 20px; "></div>
            <div class="main-box-title-14" id="i_div_u_words">{{unique_words_A1 ? unique_words_A1 : "--"}} ({{cumul_unique_A1 ? cumul_unique_A1 : "--"}}%)</div>
            <div class="main-box-title-14" id="i_div_words">{{words_A1 ? words_A1 : "--"}} ({{cumul_words_A1 ? cumul_words_A1 : "--"}}%)</div>
            <div style="width: 70px; height: 20px; "></div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['A1']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['A1']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
  
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['A2']}" (click)="toggleExpand('A2')">
            <div id="i_div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="i_div_box_score">
              <div id="i_box-score" style="background-color: #24908E;">
                <div style="text-align: center; align-items: center; width: 30px;">A2</div>
              </div>
            </div>
            <div style="width: 30px; height: 20px;"></div>
            <div class="main-box-title-14" id="i_div_u_words">{{unique_words_A2 ? unique_words_A2 : "--"}} ({{cumul_unique_A2 ? cumul_unique_A2 : "--"}}%)</div>
            <div class="main-box-title-14" id="i_div_words">{{words_A2 ? words_A2 : "--"}} ({{cumul_words_A2 ? cumul_words_A2 : "--"}}%)</div>
            <div style="width: 70px; height: 20px;"></div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['A2']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['A2']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['B1']}" (click)="toggleExpand('B1')">
            <div id="i_div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="i_div_box_score">
              <div id="i_box-score" style="background-color: #F41425;">
                <div style="text-align: center; align-items: center; width: 30px;">B1</div>
              </div>
            </div>
            <div style="width: 30px; height: 20px;"></div>
            <div class="main-box-title-14" id="i_div_u_words">{{unique_words_B1 ? unique_words_B1 : "--"}} ({{cumul_unique_B1 ? cumul_unique_B1 : "--"}}%)</div>
            <div class="main-box-title-14" id="i_div_words">{{words_B1 ? words_B1 : "--"}} ({{cumul_words_B1 ? cumul_words_B1 : "--"}}%)</div>
            <div style="width: 70px; height: 20px;"></div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['B1']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['B1']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['B2']}" (click)="toggleExpand('B2')">
            <div id="i_div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="i_div_box_score">
              <div id="i_box-score" style="background-color: #1C6C34;">
                <div style="text-align: center; align-items: center; width: 30px;">B2</div>
              </div>
            </div>
            <div style="width: 30px; height: 20px;"></div>
            <div class="main-box-title-14" id="i_div_u_words">{{unique_words_B2 ? unique_words_B2 : "--"}} ({{cumul_unique_B2 ? cumul_unique_B2 : "--"}}%)</div>
            <div class="main-box-title-14" id="i_div_words">{{words_B2 ? words_B2 : "--"}} ({{cumul_words_B2 ? cumul_words_B2 : "--"}}%)</div>
            <div style="width: 70px; height: 20px;"></div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['B2']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['B2']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['C1']}" (click)="toggleExpand('C1')">
            <div id="i_div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="i_div_box_score">
              <div id="i_box-score" style="background-color: #2C51F5;">
                <div style="text-align: center; align-items: center; width: 30px;">C1</div>
              </div>
            </div>
            <div style="width: 30px; height: 20px;"></div>
            <div class="main-box-title-14" id="i_div_u_words">{{unique_words_C1 ? unique_words_C1 : "--"}} ({{cumul_unique_C1 ? cumul_unique_C1 : "--"}}%)</div>
            <div class="main-box-title-14" id="i_div_words">{{words_C1 ? words_C1 : "--"}} ({{cumul_words_C1 ? cumul_words_C1 : "--"}}%)</div>
            <div style="width: 70px; height: 20px;"></div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['C1']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['C1']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['C2']}" (click)="toggleExpand('C2')">
            <div id="i_div_eye_icon">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="i_div_box_score">
              <div id="i_box-score" style="background-color: #8A268C;">
                <div style="text-align: center; align-items: center; width: 30px;">C2</div>
              </div>
            </div>
            <div style="width: 30px; height: 20px;"></div>
            <div class="main-box-title-14" id="i_div_u_words">{{unique_words_C2 ? unique_words_C2 : "--"}} ({{cumul_unique_C2 ? cumul_unique_C2 : "--"}}%)</div>
            <div class="main-box-title-14" id="i_div_words">{{words_C2 ? words_C2 : "--"}} ({{cumul_words_C2 ? cumul_words_C2 : "--"}}%)</div>
            <div style="width: 70px; height: 20px;"></div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['C2']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['C2']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk" >
                <p class="text-item">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div class="vertical-box">
          <div class="horizontal-box" style="border: none; margin-bottom: 0px;" [ngClass]="{'expanded': isExpanded['UNLISTED']}" (click)="toggleExpand('UNLISTED')">
            <div id="i_div_eye_icon_u">
              <img class="eye-icon"  src="../../assets/images/eye-icon.svg">
            </div>
            <div id="i_div_box_score_u">
              <div id="i_box-score_u" class="size-unlisted" style="background-color: #F3F3F5; color: #2A3654;">
                <div style="text-align: center; align-items: center; width: 30px;">Unlisted </div>
              </div>
              <div class="tooltip-container">
                <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                <span class="tooltip-text">Lorem ipsum dolor sit amet consetetur sad ipscing elitr sed diam nonumy eirmod temi por invidunt ut labore et dolore magna.</span>
              </div>
            </div>
            <div style="width: 30px; height: 20px;"></div>
            <div class="main-box-title-14" id="i_div_u_words">{{unique_words_unlisted ? unique_words_unlisted : "--"}} ({{cumul_unique_unlisted ? cumul_unique_unlisted : "--"}}%)</div>
            <div class="main-box-title-14" id="i_div_words">{{words_unlisted ? words_unlisted : "--"}} ({{cumul_words_unlisted ? cumul_words_unlisted : "--"}}%)</div>
            <div style="width: 70px; height: 20px;"></div>
            <mat-icon class="expand-icon" >expand_more</mat-icon>
          </div>
          <div class="horizontal-box" style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;" *ngIf="isExpanded['UNLISTED']">
            <div class="vertical-box" *ngFor="let chunk of dividedData['UNLISTED']" style="border: none; margin-bottom: 0px; padding: 0px;">
              <div *ngFor="let item of chunk"  >
                <p  class="text-item" style=" white-space: pre;">{{item.word}} ({{item.count}})</p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
        
      </ng-container>
  
      <!-- <div class="content-show-all">
        <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()">
          Show All
        </button>
      </div> -->
  
      <!-- <mat-checkbox color="accent" [checked]="true" disableRipple>Look for phrase matches</mat-checkbox>
      <p style="color: #2A3654; font-size: 10px;">
        Note: changing this will lose any manual changes to tagging.
      </p> -->
  
    </ng-container>
  
    <!--------------------------------------------->
    <!--------------------------------------------->
    <!----------------WORD CHARTS------------------>
    <!--------------------------------------------->
    <!--------------------------------------------->
  
    <ng-container *ngIf="selectedMenuItem === 'wc'">
  
      <div class="chart-container">
        <div
          style="width: auto;align-items: center; text-align: center; font-size: 14px; font-weight: bold; font-family: 'Inter';color: #2A3654; margin-bottom: 20px;">
          Types %</div>
        <canvas style="width: 58%; height: 200px; margin-left: 10%;margin-right: 10%; padding-bottom: 10px;" baseChart
          [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
        </canvas>
      </div>
  
  
  
    </ng-container>
  
    <ng-container *ngIf="!checked">
      <div class="text-box-bottom-simple-mode">
        <div class="line-box-bottom-simple-mode">
          <div class="bottom-text-line-simple-mode"></div>
        </div>
        <span class="main-box-title-14">To see full statistics, switch to “Advanced Mode”.</span>
      </div>
    </ng-container>
  
  </mat-card-content>
